// Services grid cards (9) for AI Call Agent
const aiCallAgentServicesData = [
  {
    title: "Cloud Consulting",
    description:
      "Expert guidance to navigate your cloud journey. We assess needs and build a tailored roadmap to maximize efficiency and performance.",
    bullets: [
      "Expert Guidance",
      "Clear Roadmap",
      "Tailored Strategies",
      "Cloud Readiness Assessment",
    ],
    minHeight: 420,
  },
  {
    title: "Cloud Migration",
    description:
      "Seamlessly migrate systems with minimal disruption. We plan, execute, and validate end-to-end migrations.",
    bullets: [
      "Seamless Transition",
      "Testing & Validation",
      "Operational Continuity",
      "Expert Execution",
    ],
    minHeight: 420,
  },
  {
    title: "Cloud Application Development",
    description:
      "Custom, secure, and scalable cloud applications built for performance and future growth.",
    bullets: [
      "Custom Application",
      "Scalable Development",
      "Performance Oriented",
      "Enhanced Operations",
    ],
    minHeight: 420,
  },
  {
    title: "Inbound AI Phone Agent",
    description:
      "Automate incoming calls with an AI agent that resolves issues, answers inquiries, and provides 24/7 customer support.",
    bullets: [
      "24/7 Availability",
      "Customer Support Automation",
      "Lead Capture",
      "Custom Knowledge Base",
    ],
    minHeight: 420,
  },
  {
    title: "Outbound AI Phone Agent",
    description:
      "Streamline outreach with AI-powered calls for reminders, surveys, and promotional campaigns to enhance engagement.",
    bullets: [
      "Proactive Outreach",
      "Appointment Setting",
      "Lead Qualification",
      "Consistent Engagement",
    ],
    minHeight: 420,
  },
  {
    title: "Fully Automated Call Solutions",
    description:
      "A complete, end-to-end AI system for managing both inbound and outbound calls with advanced automation and priority support.",
    bullets: [
      "Inbound & Outbound AI",
      "Advanced Automations",
      "High-Quality Sound",
      "Priority Support",
    ],
    minHeight: 420,
  },
  {
    title: "Custom AI Development",
    description:
      "Tailor your AI solutions to meet specific business requirements, from custom conversation flows to specialized knowledge.",
    bullets: [
      "Custom AI Flows",
      "Business-Specific Logic",
      "Custom Language Support",
      "Rigorous Testing",
    ],
    minHeight: 420,
  },
  {
    title: "AI Analytics & Reporting",
    description:
      "Gain valuable insights from your call data with a comprehensive dashboard, viewable transcripts, and full call recordings.",
    bullets: [
      "Analytics Dashboard",
      "Viewable Transcripts",
      "Full Call Recordings",
      "Performance Insights",
    ],
    minHeight: 420,
  },
  {
    title: "AI System Integration",
    description:
      "Integrate our AI solutions with your existing software and business processes for a seamless operational workflow.",
    bullets: [
      "Deep Website Integration",
      "Existing Software Sync",
      "Weekly Development Calls",
      "Secure & Compliant",
    ],
    minHeight: 420,
  },
];

export default aiCallAgentServicesData;

// Onboarding steps for timeline and accordion
export const aiCallAgentOnboardingSteps = [
  {
    id: 1,
    title: "Discovery & Strategy Call",
    activities: ["Needs Analysis", "Goal Setting", "Use-Case Identification"],
    outcome: "A detailed project plan and a defined scope of work.",
    icon: "search",
    color: "#F48428",
  },
  {
    id: 2,
    title: "AI Training & Integration",
    activities: [
      "Knowledge Base Creation",
      "CRM Integration",
      "Custom Flow Development",
    ],
    outcome: "A fully trained, integrated AI agent ready for testing.",
    icon: "brain",
    color: "#5fb2ff",
  },
  {
    id: 3,
    title: "Quality Assurance & Launch",
    activities: [
      "Scenario Testing",
      "User Acceptance Testing (UAT)",
      "Go-Live",
    ],
    outcome: "A flawless, production-ready AI agent handling live calls.",
    icon: "rocket",
    color: "#58c28e",
  },
  {
    id: 4,
    title: "Optimize & Scale",
    activities: [
      "Performance Monitoring",
      "A/B Testing",
      "Continuous Learning",
    ],
    outcome: "Continuously improving ROI and customer satisfaction.",
    icon: "chart",
    color: "#e1a21f",
  },
];

// Performance metrics dataset
export const aiCallAgentPerformanceData = {
  efficiency: {
    aht: { from: "4m 15s", to: "2m 30s", badge: "40% faster" },
    fcr: 92, // percent
    containment: 85, // percent
  },
  finance: {
    costPerInteraction: { live: 8.0, ai: 0.75, badge: "90%+ savings" },
    monthlySavings: 15200,
    baseVolume: "Based on 10,000 calls/month",
  },
  conversion: {
    leadQualification: 75, // percent
    csat: "4.8 / 5.0",
    sentiment: { positive: 88, neutral: 9, negative: 3 },
    topIntents: [
      { name: "Order_Status_Inquiry", pct: 35 },
      { name: "Make_A_Payment", pct: 22 },
      { name: "Schedule_Appointment", pct: 18 },
      { name: "Product_Information", pct: 15 },
      { name: "Technical_Support", pct: 10 },
    ],
    whyMatters: [
      { label: "Smarter routing and prioritization", color: "#F48428" },
      { label: "Self‑service optimization", color: "#5fb2ff" },
      { label: "Continuous model improvements", color: "#58c28e" },
    ],
  },
};
